import React from 'react';
import { Form, Radio, Divider } from 'antd';
import { MultiLangInput } from './shared/MultiLangInput';

export const WorkingHoursSettings: React.FC = () => {
  return (
    <>
      <Divider orientation="left">Режим работы</Divider>
      <Form.Item
        label="Режим работы"
        name="working_mode"
        rules={[{ required: true }]}
      >
        <Radio.Group>
          <Radio value="24_7">Круглосуточно (24/7)</Radio>
          <Radio value="scheduled">По расписанию</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item noStyle shouldUpdate={(prev, curr) => prev.working_mode !== curr.working_mode}>
        {({ getFieldValue }) => 
          getFieldValue('working_mode') === 'scheduled' && (
            <MultiLangInput
              namePrefix="working_hours"
              label="Часы работы"
              type="textarea"
              required
              rows={3}
              placeholder="Пн-Пт: 9:00-21:00, Сб-Вс: 10:00-20:00"
            />
          )
        }
      </Form.Item>
    </>
  );
};